module.exports = __webpack_public_path__ + "static/img/1-1.ee0b4e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/1-1.png
// module id = 0eiY
// module chunks = 0